import { render } from "./_id.vue?vue&type=template&id=84d821a4&scoped=true&ts=true"
import script from "./_id.vue?vue&type=script&lang=ts"
export * from "./_id.vue?vue&type=script&lang=ts"

import "./_id.vue?vue&type=style&index=0&id=84d821a4&scoped=true&lang=css"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84d821a4"]])

export default __exports__